import { Box, Typography, Grid } from "@mui/material";
import { Can } from "../../../shared/components/Permission";
import { useQuery } from "@tanstack/react-query";
import { statisticsService } from "../services/dashboardService";
import { SummaryCard } from "../components/SummaryCard";
import PeopleIcon from "@mui/icons-material/People";
import EventIcon from "@mui/icons-material/Event";
import GroupIcon from "@mui/icons-material/Group";
import { ParticipantsBarChart } from "../components/ParticipantsBarChart";
import { DashboardSkeleton } from "../components/DashboardSkeleton";
import { EventsByMonthBarChart } from "../components/EventsByMonthBarChart";

const Dashboard = () => {
  const { data: statistics, isLoading } = useQuery({
    queryKey: ['dashboard-statistics'],
    queryFn: statisticsService.getStatistics,
  });

  if (isLoading || !statistics) {
    return <DashboardSkeleton />;
  }

  return (
    <>
      <Can roles={['ADMIN']}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography variant="h5" fontWeight={700}>
            Dashboard
          </Typography>
        </Box>
      </Can>

      {/* Cards de resumo */}
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<PeopleIcon fontSize="large" color="secondary" />}
            value={statistics.totalParticipants}
            label="Total de Participantes"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<EventIcon fontSize="large" color="primary" />}
            value={statistics.totalEvents}
            label="Total de Eventos"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            icon={<GroupIcon fontSize="large" color="primary" />}
            value={statistics.totalOrganizers}
            label="Total de Organizadores"
          />
        </Grid>
      </Grid>

      {/* Gráfico de participantes por evento */}
      <Box mt={2}>
        <ParticipantsBarChart events={statistics.participantsByEvent} />
      </Box>

      <Box mt={4}>
        <EventsByMonthBarChart eventsByMonth={statistics.eventsByMonth} />
      </Box>
    </>
  );
};

export default Dashboard;